import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { COMPONENT } from 'utils/constants'
import copy from 'copy-to-clipboard'
import Paragraph from 'components/patterns/Typography/Paragraph'
import Tooltip from 'components/chec/ChecTooltip'
import styled from '@emotion/styled'
import strings from 'utils/strings'
import Button from 'components/patterns/Button'
import Header from 'components/patterns/Typography/Header'

const StyledHeader = styled(Header)`
  margin-top: 50px !important;
  margin-bottom 20px !important;
`

const StyledParagraph = styled(Paragraph)`
  margin-bottom: 8px !important;
`

export default function DefaultError({ level, error }) {
  const history = useHistory()
  const errorMessage = () => (
    <>
      <StyledParagraph>
        If you would like to report an error to the CHEC Team, you can help us
        by sending an email with the following details:
      </StyledParagraph>
      <ol>
        <li>
          <StyledParagraph>
            Let us know what you were doing, such as logging in, navigating to a
            specific page, creating a Feature, or another task.
          </StyledParagraph>
        </li>
        <li>
          <StyledParagraph>
            Include VIN, Reference Parameter numbers, Feature numbers, or any
            additional helpful details.
          </StyledParagraph>
        </li>
        <li>
          <StyledParagraph>
            <Tooltip trigger="click" placement="top" title="Copied">
              <span
                className="link"
                onClick={copyError}
                title={error.stack || error}
              >
                Click here
              </span>
            </Tooltip>{' '}
            to copy the error code.
          </StyledParagraph>
        </li>
      </ol>

      <StyledParagraph>
        Please send us an email at{' '}
        <a href="mailto:checsupport@daimlertruck.com?subject=Reporting%20CHEC%20Error">
          checsupport@daimlertruck.com
        </a>
        . Our goal is to respond promptly.
      </StyledParagraph>
    </>
  )

  const returnHome = () => {
    if (window) {
      history.replace('/chec')
    } else {
      history.push('/')
    }
  }

  const copyError = () => {
    copy(error.stack)
  }

  const componentLevelError = level === COMPONENT
  const header = strings.error_boundary_header
  return (
    <div className={`${level}-error`}>
      <StyledHeader className="header">{header}</StyledHeader>
      {errorMessage()}
      {componentLevelError && (
        <Button size="large" onClick={returnHome}>
          {strings.chec_home}
        </Button>
      )}
    </div>
  )
}

DefaultError.propTypes = {
  message: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object,
    PropTypes.string,
  ]),
  level: PropTypes.oneOf(['app', 'component']),
}
